import { BrandInterface } from "../interface";
import base from "./index";

const resortBase = {
  ...base,
  fontFamily: "proxima-nova, sans-serif",
  color: {
    ...base.color,
    textColor: "#252525",
    textColorAlt: "#ffffff",
    header: "#ffffff",
    buttonText: "#ffffff",
    input: "#63666A",
    inputFocus: "#252525",
    inputError: "#EA1609",
    inputErrorText: "#D91208",
    inputLabel: "#252525",
    inputLabelError: "#D91208",
    inputBackground: "#f4f4f4",
    error: "#D91208",
  },
} as BrandInterface;

export default resortBase;
